import React from "react";

import { StatusBadgeProps } from "./statusBadgeProps";

export const NewStatusBadge = (props: StatusBadgeProps) => {
    const { width, height = "18", viewBox = "0 0 37 18", ...rest } = props;

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox={viewBox}
            {...rest}
            data-cy="newBadge"
        >
            <g
                fill="none"
                fillRule="evenodd"
                stroke="none"
                strokeWidth="1"
                transform="translate(-957 -10082) translate(957 10082)"
            >
                <rect
                    width="37"
                    height="18"
                    x="0"
                    y="0"
                    fill="#A6D3F4"
                    rx="1.966"
                ></rect>
                <path
                    fill="#210071"
                    fillRule="nonzero"
                    d="M10.745 5h1.153v7.915h-1.215L7.16 6.977v5.938H6V5h1.21l3.535 5.915V5zm3.355 7.915V5h5.237v1.11h-4.033v2.285h3.709v1.109h-3.709v2.274h4.033v1.137H14.1zm8.548 0L20.307 5h1.254l1.765 6.156 1.854-5.708h.947l1.854 5.708L29.75 5H31l-2.341 7.915h-1.177l-1.826-5.568-1.832 5.568h-1.176z"
                ></path>
            </g>
        </svg>
    );
};
